export default "__VITE_ASSET__CCkAfT_e__ 1200w";